import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import "./WorkExperienceCard.css"; // Kept for unique timeline styles
import WorkExperienceModal from "../Common_profile_details_modals/WorkExperienceModal/WorkExperienceModal";
import WorkExperienceChart from "./WorkExperienceChart/WorkExperienceChart";

const WorkExperienceCard = () => {
  const [expanded, setExpanded] = useState({
    first: false,
    second: false,
  });

  const firstDescription =
    "Developed and launched 5+ dynamic, high-traffic websites using React, HTML, CSS, and Bootstrap, leading to a 25% increase in user engagement and a 15% reduction in bounce rates. Spearheaded the implementation of JavaScript-driven functionalities, enhancing user interactivity and improving overall website usability by 30%. Collaborated with UI/UX designers to deliver responsive and accessible web applications while ensuring cross-browser compatibility and performance optimization.";

  const secondDescription =
    "Developed and deployed 4+ fully responsive websites, improving client satisfaction by 20% due to seamless design across devices and browsers. Optimized websites for mobile-first design, resulting in a 30% increase in mobile traffic. Worked closely with backend developers to integrate REST APIs and implemented reusable React components to improve maintainability and scalability.";
  // --- Work Experience Modal State ---
  const [showWorkModal, setShowWorkModal] = useState(false);
  const handleOpenWorkModal = () => {
    setShowWorkModal(true); // Open WorkExperienceModal
  };

  const handleCloseWorkModal = () => {
    setShowWorkModal(false);
  };
  return (
    <>
      <Card className="profile-card-pattern WorkExperienceCard">
        <Card.Body className="profile-card-pattern__body">
          {/* Pattern Header */}
          <div className="profile-card-pattern__header">
            <h3 className="profile-card-pattern__title">Work experience</h3>
            <Button
              variant="link"
              className="profile-card-pattern__btn-add"
              aria-label="Add work experience"
            >
              <span
                className="summary-card__edit-icon"
                onClick={handleOpenWorkModal}
              >
                ➕
              </span>
            </Button>
          </div>

          {/* Timeline Dynamic Graph Container (Unique to Work Exp) */}
          <div className="work-exp-timeline">
            <WorkExperienceChart />
          </div>

          {/* Experience Blocks matching Pattern A structural hierarchy */}
          <div className="profile-pattern-block-list">
            {/* Experience Item 1 */}
            <div className="profile-pattern-block__item d-flex gap-3">
              <div className="work-exp-company-icon">
                <span className="summary-card__edit-icon">🏢</span>
              </div>
              <div className="flex-grow-1">
                <p
                  className="profile-pattern-block__sub-text"
                  style={{ margin: 0 }}
                >
                  Profcyma Global Solutions
                </p>

                <div className="profile-pattern-block__item-header">
                  <h4 className="profile-pattern-block__main-text">
                    Frontend Development Engineer
                  </h4>
                  <Button
                    variant="link"
                    className="profile-card-pattern__btn-edit"
                    aria-label="Edit role"
                  >
                    <span
                      className="summary-card__edit-icon"
                      onClick={handleOpenWorkModal}
                    >
                      ✏️
                    </span>
                  </Button>
                </div>

                <p className="profile-pattern-block__meta-text">
                  Jun 2023 - Present (3 yrs, 1 m) • Salary: INR 3.2L (Annually)
                  • Notice Period: 15 days
                </p>
                <p className="work-exp-description-text">
                  {expanded.first
                    ? firstDescription
                    : `${firstDescription.substring(0, 180)}...`}

                  <span
                    className="work-exp-read-more"
                    onClick={() =>
                      setExpanded((prev) => ({
                        ...prev,
                        first: !prev.first,
                      }))
                    }
                  >
                    {expanded.first ? " Read less" : " Read more"}
                  </span>
                </p>
              </div>
            </div>

            {/* Experience Item 2 */}
            <div className="profile-pattern-block__item d-flex gap-3">
              <div className="work-exp-company-icon">
                <span className="summary-card__edit-icon">🏢</span>
              </div>
              <div className="flex-grow-1">
                <p
                  className="profile-pattern-block__sub-text"
                  style={{ margin: 0 }}
                >
                  Pratian Technologies
                </p>

                <div className="profile-pattern-block__item-header">
                  <h4 className="profile-pattern-block__main-text">
                    Frontend Development Engineer
                  </h4>
                  <Button
                    variant="link"
                    className="profile-card-pattern__btn-edit"
                    aria-label="Edit role"
                  >
                    <span
                      className="summary-card__edit-icon"
                      onClick={handleOpenWorkModal}
                    >
                      ✏️
                    </span>
                  </Button>
                </div>

                <p className="profile-pattern-block__meta-text">
                  Aug 2022 - Apr 2023 (8 m)
                </p>
                <p className="work-exp-description-text">
                  {expanded.second
                    ? secondDescription
                    : `${secondDescription.substring(0, 180)}...`}

                  <span
                    className="work-exp-read-more"
                    onClick={() =>
                      setExpanded((prev) => ({
                        ...prev,
                        second: !prev.second,
                      }))
                    }
                  >
                    {expanded.second ? " Read less" : " Read more"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      <WorkExperienceModal
        show={showWorkModal}
        handleClose={handleCloseWorkModal}
      />
    </>
  );
};

export default WorkExperienceCard;
